"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Table: function() {
        return _index.Table;
    },
    renderTable_unstable: function() {
        return _index.renderTable_unstable;
    },
    tableClassName: function() {
        return _index.tableClassName;
    },
    tableClassNames: function() {
        return _index.tableClassNames;
    },
    useTableStyles_unstable: function() {
        return _index.useTableStyles_unstable;
    },
    useTable_unstable: function() {
        return _index.useTable_unstable;
    }
});
const _index = require("./components/Table/index");
